<div class="poker-secure-popup">
  <div class="poker-secure-popup__modal"></div>
  <div class="secure-popup secure-popup__password">
    <div class="secure-head">
      <h3><img src="{{imagePath}}/img/secure/h1_personal.png" alt="개인암호"></h3>
      <a data-passwd-click="cancel" href="#" class="secure-close"></a>
    </div>
    <div class="secure-body">
      <p class="message">
        개인암호를 입력하세요.
      </p>
      <div class="secure-input">
        <div class="secure-input__number">
          <input data-passwd-input type="text" class="secure-input__password" value="{{displayValue}}" disabled>
        </div>
        <a href="{{changePWLink}}" target="_blank" class="secure-btn__password-change">개인암호 변경</a>
        <a href="{{unregisterLink}}" target="_blank" class="secure-btn__password-cancel">개인암호 해지</a>
      </div>
      <div class="secure-numberpad">
        {{#each padNumbers}}
        <a href="#" data-passwd-click="number" class="pad-number">{{this}}</a>
        {{/each}}

        <a href="#" data-passwd-click="reset" class="pad-del">전체지움</a>
        <a href="#" data-passwd-click="confirm"
          class="secure-btn__pad-confirm {{#unless isReady}}secure-btn--off{{/unless}}">확인</a>
      </div>
    </div>
  </div>
</div>